import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { meApi, surveyApi, type MeInfo } from '../../api/client';
import { Icon } from '../../components/Icon';

export function MePage() {
  const navigate = useNavigate();
  const [me, setMe] = useState<MeInfo | null>(null);
  const [pendingSurvey, setPendingSurvey] = useState<{ id: string; title: string } | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    meApi.get()
      .then(data => setMe(data.employee))
      .catch(e => setError(e instanceof Error ? e.message : '加载失败'))
      .finally(() => setLoading(false));
    // 待填写满意度问卷（有则在顶部提醒）
    surveyApi.pending()
      .then(d => setPendingSurvey(d.pending ? { id: d.pending.id, title: d.pending.title } : null))
      .catch(() => { /* 无问卷或加载失败均静默 */ });
  }, []);

  function logout() {
    localStorage.removeItem('emp_token');
    localStorage.removeItem('emp_code');
    localStorage.removeItem('emp_tenant_id');
    navigate('/auth');
  }

  if (loading) return <div className="loading-state"><span className="spinner" /></div>;

  return (
    <div className="page">
      <h1>我的</h1>

      {error && <p style={{ color: 'var(--color-danger)', fontSize: 13 }}>{error}</p>}

      <div className="me-card" style={{ background: '#fff', borderRadius: 12, padding: 20, marginTop: 8 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 20 }}>
          <div style={{ width: 52, height: 52, borderRadius: '50%', background: '#4f46e5', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, fontWeight: 700 }}>
            {(me?.code || '?').slice(0, 2)}
          </div>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700 }}>{me?.code || '未绑定'}</div>
            <div style={{ color: 'var(--gray-500)', fontSize: 13 }}>{me?.tenant_name || me?.tenant_id || '—'}</div>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {pendingSurvey && (
            <Link
              to={`/survey/${pendingSurvey.id}`}
              className="me-row"
              style={{
                display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px',
                borderRadius: 8, background: '#fff7e6', border: '1px solid #ffd591',
                textDecoration: 'none', color: '#ad4e00',
              }}
            >
              <span style={{ fontSize: 18 }}>📋</span>
              <span style={{ flex: 1, fontWeight: 600 }}>满意度调查待填写</span>
              <Icon name="chevron-right" size={16} color="#ad4e00" />
            </Link>
          )}
          <Link to="/wrong-book" className="me-row" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', borderRadius: 8, background: '#f8f9fa', textDecoration: 'none', color: '#333' }}>
            <Icon name="book" size={18} color="#4f46e5" />
            <span style={{ flex: 1 }}>错题本</span>
            <Icon name="chevron-right" size={16} color="var(--gray-400)" />
          </Link>
          <Link to="/stats" className="me-row" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', borderRadius: 8, background: '#f8f9fa', textDecoration: 'none', color: '#333' }}>
            <Icon name="chart" size={18} color="#4f46e5" />
            <span style={{ flex: 1 }}>学习统计</span>
            <Icon name="chevron-right" size={16} color="var(--gray-400)" />
          </Link>
          <Link to="/ranking" className="me-row" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', borderRadius: 8, background: '#f8f9fa', textDecoration: 'none', color: '#333' }}>
            <Icon name="trophy" size={18} color="#4f46e5" />
            <span style={{ flex: 1 }}>企业排名</span>
            <Icon name="chevron-right" size={16} color="var(--gray-400)" />
          </Link>
          <Link to="/cert" className="me-row" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', borderRadius: 8, background: '#f8f9fa', textDecoration: 'none', color: '#333' }}>
            <Icon name="medal" size={18} color="#b8860b" />
            <span style={{ flex: 1 }}>我的人才学习档案</span>
            <Icon name="chevron-right" size={16} color="var(--gray-400)" />
          </Link>
        </div>
      </div>

      <button
        onClick={logout}
        style={{
          width: '100%', marginTop: 20, padding: '12px 16px', borderRadius: 8,
          background: '#fff', border: '1px solid #fca5a5', color: '#dc2626',
          fontSize: 15, fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
          cursor: 'pointer',
        }}
      >
        <Icon name="logout" size={18} color="#dc2626" /> 退出登录
      </button>
    </div>
  );
}
